import React from 'react';
import { LightTooltipComponent } from 'aurora-components';
import FILTERS_NAMES from 'aurora-utils/filtersNames';
import { keyEmptyCheck } from 'aurora-utils/utils';

function useFiltersActions() {
  function transformDropDownData(filterName, dropDownData) {
    switch (filterName) {
      case FILTERS_NAMES.STATUS:
        return dropDownData.map(option => {
          const toolTipTitles = {
            UNDER_CONSTRUCTION: 'under_construction_project_status_tooltip_message',
            COMPLETED: 'completed_project_status_tooltip_message',
            READY: 'ready_project_status_tooltip_message',
          };
          return {
            ...option,
            label: (
              <>
                <LightTooltipComponent title={keyEmptyCheck(toolTipTitles[option?.value])} dark>
                  <div>
                    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15' fill='none'>
                      <g clipPath='url(#clip0_5_29803)'>
                        <path
                          d='M7.5 15C6.01664 15 4.5666 14.5601 3.33323 13.736C2.09986 12.9119 1.13856 11.7406 0.570907 10.3701C0.00324965 8.99968 -0.145275 7.49168 0.144114 6.03683C0.433503 4.58197 1.14781 3.2456 2.1967 2.1967C3.2456 1.14781 4.58197 0.433503 6.03683 0.144114C7.49168 -0.145275 8.99968 0.00324965 10.3701 0.570907C11.7406 1.13856 12.9119 2.09986 13.736 3.33323C14.5601 4.5666 15 6.01664 15 7.5C14.9979 9.48847 14.207 11.3949 12.8009 12.8009C11.3949 14.207 9.48847 14.9979 7.5 15ZM7.5 1.25C6.26387 1.25 5.0555 1.61656 4.02769 2.30332C2.99988 2.99008 2.1988 3.96619 1.72576 5.10823C1.25271 6.25027 1.12894 7.50694 1.3701 8.71932C1.61125 9.9317 2.20651 11.0453 3.08059 11.9194C3.95466 12.7935 5.06831 13.3888 6.28069 13.6299C7.49307 13.8711 8.74974 13.7473 9.89178 13.2743C11.0338 12.8012 12.0099 12.0001 12.6967 10.9723C13.3834 9.94451 13.75 8.73614 13.75 7.5C13.7482 5.84296 13.0891 4.2543 11.9174 3.0826C10.7457 1.91089 9.15705 1.25182 7.5 1.25Z'
                          fill='currentColor'
                        />
                        <path
                          d='M8.75 11.875H7.5V7.5H6.25V6.25H7.5C7.83152 6.25 8.14946 6.3817 8.38388 6.61612C8.6183 6.85054 8.75 7.16848 8.75 7.5V11.875Z'
                          fill='currentColor'
                        />
                        <path
                          d='M7.5 5C8.01777 5 8.4375 4.58027 8.4375 4.0625C8.4375 3.54473 8.01777 3.125 7.5 3.125C6.98223 3.125 6.5625 3.54473 6.5625 4.0625C6.5625 4.58027 6.98223 5 7.5 5Z'
                          fill='currentColor'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0_5_29803'>
                          <rect width='15' height='15' fill='white' />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </LightTooltipComponent>
                {option?.label}
              </>
            ),
          };
        });
      default:
        return dropDownData;
    }
  }

  return {
    transformDropDownData,
  };
}

export default useFiltersActions;
